import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.cpms-srlkevcharge.com';

function UtilisationGauge({ percent }) {
  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(percent, 100) / 100) * circumference;
  const color = percent > 90 ? '#ef4444' : percent > 70 ? '#f59e0b' : '#1f9a4c';

  return (
    <div className="lm-station-card-gauge">
      <svg width="72" height="72" viewBox="0 0 72 72">
        <circle cx="36" cy="36" r={radius} fill="none" stroke="#f1f5f9" strokeWidth="7" />
        <circle
          cx="36" cy="36" r={radius} fill="none" stroke={color} strokeWidth="7"
          strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round"
        />
      </svg>
      <div className="lm-station-card-gauge-value">{percent}%</div>
    </div>
  );
}

export default function LoadManagementList() {
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchStations = async () => {
    try {
      const res = await axios.get(`${API}/load-management/`);
      setStations(res.data.stations);
    } catch (e) {
      console.error('Failed to fetch load management overview', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStations();
    const t = setInterval(fetchStations, 15000);
    return () => clearInterval(t);
  }, []);

  if (loading) return <div className="loading">Loading stations...</div>;

  return (
    <>
      <div className="page-header">
        <h1>Load Management</h1>
        <p>Site power capacity and live charger allocation across the network</p>
      </div>

      {stations.length === 0 ? (
        <div className="card empty-state">
          <h3>No stations registered yet</h3>
          <p>Register a station via Add EVSE to start configuring load management.</p>
        </div>
      ) : (
        <div className="lm-station-grid">
          {stations.map(station => (
            <div
              key={station.location_id}
              className="lm-station-card"
              onClick={() => navigate(`/load-management/${station.location_id}`)}
            >
              <div className="lm-station-card-header">
                <div>
                  <div className="lm-station-card-name">{station.station_name}</div>
                  <div className="lm-station-card-org">{station.organisation_name}</div>
                </div>
                {!station.is_configured && (
                  <span className="lm-station-unconfigured-badge">Not configured</span>
                )}
              </div>

              <div className="lm-station-card-gauge-wrap">
                <UtilisationGauge percent={station.site_utilisation_percent} />
                <div className="lm-station-card-stats">
                  <div className="lm-station-card-stat-row">
                    <span className="lm-station-card-stat-label">Site Capacity</span>
                    <span className="lm-station-card-stat-value">{station.site_capacity_kw} kW</span>
                  </div>
                  <div className="lm-station-card-stat-row">
                    <span className="lm-station-card-stat-label">EV Load</span>
                    <span className="lm-station-card-stat-value">{station.ev_charging_load_kw} kW</span>
                  </div>
                  <div className="lm-station-card-stat-row">
                    <span className="lm-station-card-stat-label">Available</span>
                    <span className="lm-station-card-stat-value">{station.available_capacity_kw} kW</span>
                  </div>
                </div>
              </div>

              <div className="lm-station-card-footer">
                <span className="lm-station-card-chargers">{station.total_chargers} charger{station.total_chargers !== 1 ? 's' : ''}</span>
                <span className={`lm-station-card-active-pill ${station.active_chargers === 0 ? 'zero' : ''}`}>
                  {station.active_chargers} active
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}